import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../../components/Footer';
import {
    GraduationCap,
    Stars,
    Clock,
    Bookmark,
    ArrowUpRight,
    Users,
    BookOpen,
    Award,
    Globe,
    Rocket,
    Leaf,
    Briefcase,
    Target,
    Flag,
    Share2,
    Building,
    Wrench,
    CheckCircle,
    MonitorPlay,
    ChevronRight,
    ArrowRight,
    Zap,
    Shield,
    Code,
    Database,
    Server,
    LucideSearch,
    Activity,
    MessageSquareQuote
} from 'lucide-react';
import { Link } from 'react-router-dom';
import AgriImg from "../../../assets/images/agriculture.jpeg";
import Title from '../../../components/TitleComponent';
import { FaTrophy, FaUsers, FaUserGraduate, FaQuoteLeft, FaChevronLeft, FaChevronRight, FaLeaf, FaAward, FaMedal } from 'react-icons/fa';
import chatlapalli from '../../../assets/schools/agri/chatlapalli.jpg';
import rahul from '../../../assets/schools/agri/rahul.jpg';
import Himanshu from '../../../assets/schools/agri/himanshu saini.png';
import saurabh from '../../../assets/schools/agri/saurabh.jpg';
import shashikant from '../../../assets/schools/agri/shashikant.jpg';
import vaishali from '../../../assets/schools/agri/vaishali.jpg';
import agri1 from '../../../assets/schools/agri/agri1.webp';
import agri2 from '../../../assets/schools/agri/agri2.webp';

const btechCourses = [
    { name: "Dairy Technology", path: "btech/btech-dairy-technology-colleges-in-dehradun-uttarakhnad" },
    
];

const bscCourses = [
    { name: "B.Sc(Hons) Agriculture", path: "bsc/bsc-agriculture-colleges-in-dehradun-uttarakhnad" },
    { name: "B.Sc(Hons) Food Technology", path: "btech/food-technology" },
    // { name: "Horticulture", path: "bsc/horticulture-colleges-in-dehradun-uttarakhand" },
    // { name: "Microbiology", path: "bsc/best-bsc-microbiology-colleges-in-dehradun-uttarakhand" },
    
    { name: "B.Sc Food Technology", path: "btech/food-technology" }
];

const mscCourses = [
    { name: "Masters in Agronomy", path: "msc/agronomy" },
    { name: "Masters in Horticulture", path: "msc/horticulture-colleges-in-dehradun-uttarakhand" },
    { name: "Masters in Food Technology", path: "msc/food-technology" },
    // { name: "Masters in Microbiology", path: "msc/best-msc-microbiology-colleges-in-dehradun-uttarakhand" },
    { name: "Masters in Genetics and Plant Breeding", path: "msc/genetics-and-plant-breeding" },
    // { name: "Masters in Nutrition and Dietetics", path: "msc/nutrition-and-dietetics" }
];

const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 md:my-8 px-4"
    >
        {[
            { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "1000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "11+", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "85%", label: "Placement Rate", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "30+", label: "Research Projects", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);

const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-8 rounded-xl shadow-lg mb-12"
    >
        <div className="flex flex-col lg:flex-row gap-8 items-center">
            <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                        <BookOpen className="w-6 h-6" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">About</h2>
                </div>
                <div className="space-y-4 text-gray-700 text-lg">
                    <p>The School of Agriculture and Technology, Maya Devi University, Selaqui, Dehradun is a dynamic academic and research institution committed to advancing sustainable agricultural practices, technological innovation and rural development. The department of Agriculture was established in 2013 and school of Agriculture & Technology in 2024. The school addresses the evolving challenges in food production, environmental sustainability and technological advancement and plays a vital role in training the next generation of professionals in agriculture and allied sciences. Rooted in a tradition of excellence and practical learning, the school offers programs that integrate modern scientific knowledge with hands-on experience in areas such as plant breeding, crop and soil science, horticultural sciences, agricultural engineering, food technology, microbiology, biochemistry, plant biotechnology and environmental management. The curriculum is designed to meet the needs of a rapidly changing agricultural landscape and to equip students with the skills to drive innovation and impact.</p>

                    <p>Our key focus areas are: Sustainable crop production, Soil health and fertility management, Climate-resilient agriculture, Farm machinery and automation, Water resource management, post-harvest handling and storage technologies, Waste-to-bioenergy conversion through microbial processes, Genetic improvement of crops, Genetic engineering of microbes for enhanced agricultural applications, Molecular biology and biotechnology applications, Bioinformatics and emerging technologies, Sustainable land use and conservation, Agroforestry and biodiversity, Climate-smart agriculture practices, Precision agriculture and data-driven farming, Farmer education and outreach programs, Community-based innovation and rural empowerment.

                    </p>
                </div>
            </div>
            <div className="w-full lg:w-1/2 relative h-80 md:h-96 rounded-xl overflow-hidden shadow-xl">
                <img
                    src={agri1}
                    alt="School of Agriculture"
                    className="w-full h-full object-cover rounded-xl transition-transform duration-700 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e4d38]/70 to-transparent flex items-end">
                    <div className="p-6">
                        <h3 className="text-white text-xl font-bold">Cutting-edge Learning Environment</h3>
                        <p className="text-white/80 text-sm">Modern classrooms and advanced computer labs</p>
                    </div>
                </div>
            </div>
        </div>
    </motion.div>
);


const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            <Leaf className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {/* <span>{course.name.includes('Masters in') ? '2 Years' : course.name.includes('B.Tech') ? '4 Years' : '4 Years'}</span> */}
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        {/* <span>{course.name.includes('M.Sc') ? 'PG' : 'UG'}</span> */}
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon, courses }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {courses.map((course, index) => (
                <CourseCard key={index} course={course} index={index} />
            ))}
        </div>
    </motion.div>
);

const DeansWelcome = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-8 rounded-xl shadow-lg mb-12"
    >
        <div className="flex flex-col md:flex-row gap-8">
            <div className="w-full md:w-1/3">
                <div className="rounded-xl overflow-hidden shadow-xl">
                    <img
                        src="/api/placeholder/400/500"
                        alt="Dean of School of Computer Applications"
                        className="w-full h-auto"
                    />
                </div>
            </div>
            <div className="w-full md:w-2/3">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                        <Award className="w-6 h-6" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Dean's Welcome Note</h2>
                </div>
                <div className="space-y-4 text-gray-700">
                    <p className="text-lg italic">"Dear Students, Faculty, and Visitors,"</p>
                    <p>Welcome to another exciting chapter in your academic journey here at the School of Agriculture and Technology. Whether you are just beginning or continuing your studies, know that you are part of a vibrant and growing community dedicated to innovation, sustainability and the betterment of our world through agricultural science.</p>
                    <p>The challenges facing global agriculture today are climate change, food security, sustainable farming, require bold ideas, rigorous research and passionate professionals. You are the future of this vital field and we are committed to providing you with the knowledge, skills, and experiences you need to lead and inspire change.</p>
                    <p>Our school is a hub of knowledge, discovery, and impact. We offer a wide array of programs and courses designed to give you a strong foundation in both traditional and modern agricultural sciences. I encourage each of you to make the most of the opportunities here: engage in research, connect with our dedicated faculty, participate in internships, and collaborate with your peers. Together, we can advance solutions that make a real difference in communities locally and globally.</p>
                    <p className="font-semibold">Let us work together to cultivate not just crops and livestock, but also curiosity, leadership and resilience. I look forward to seeing all that you will accomplish.</p>
                    <p className="font-bold text-[#0e4d38]">Prof. (Dr.) Himanshu Saini</p>
                    {/* <p className="text-gray-600">Dean, School of Computer Applications<br />Maya Devi University</p> */}
                </div>
            </div>
        </div>
    </motion.div>
);





const AchievementsSection = () => {
    const [activeTestimonial, setActiveTestimonial] = React.useState(0);

  const awards = [
    {
      id: 1,
      faculty: "Prof. (Dr.) Himanshu Saini",
      award: "National Summit of Institutional Leaders NSIL - 2025",
      date: "March 01-02, 2025",
      agency: "VBUSS, Doon University, Dehradun & Department of Higher Education, Govt. of Uttarakhand"
    },
    {
      id: 2,
      faculty: "Prof. (Dr.) Himanshu Saini",
      award: "One day workshop on 'The Art of Writing Research/Review Publications and Research Proposals'",
      date: "January 04, 2025",
      agency: "Maya Devi University, Dehradun"
    },
    {
      id: 3,
      faculty: "Prof. (Dr.) Himanshu Saini",
      award: "Krishi Vigyan Mela - 2.0",
      date: "December 10-11, 2024",
      agency: "Maya Devi University, Dehradun"
    },
    {
      id: 4,
      faculty: "Prof. (Dr.) Himanshu Saini",
      award: "National Conference on 'New Education Policy - India Towards Developed Nation by 2047'",
      date: "October 05, 2024",
      agency: "Maya Devi University, Dehradun"
    }
  ];

  const clubs = [
    "Agri-Sport",
    "The Crop Crew",
    "The Golden Grains"
  ];

  const testimonials = [
    {
      id: 1,
      name: "Chatlapalli Sunil Reddy",
      company: "Brigade group (real estate)",
      department: "Marketing sales",
      position: "Zonal Head",
      course: "B.Sc. Agriculture",
      batch: "2017-2021",
      ctc: "21 LPA",
      image: chatlapalli,
      quote: "I am proud to be an alumnus of Maya Devi University, where I completed my B.Sc. Agriculture in 2021. My time at the university played a vital role in shaping my academic and professional journey. The experienced faculty, well-structured curriculum and hands-on learning opportunities helped me build a strong foundation in my field. I carry forward the values and knowledge gained at Maya Devi University with great pride."
    },
    {
      id: 2,
      name: "Rahul Raj Kumar",
      company: "Aditya Birla Group",
      department: "Agriculture",
      position: "Sales Manager",
      course: "B.Sc Agriculture",
      batch: "2019-2023",
      ctc: "12 LPA",
      image: rahul,
      quote: "Looking back, my time at Maya Devi University was truly transformative. It wasn't just about lectures and exams, it was where I discovered my strengths, formed lifelong friendships and grew both academically and personally. The guidance I received from mentors and the exposure to real-world learning shaped who I am today."
    },
    {
      id: 3,
      name: "Saurabh",
      company: "Punjab National Bank",
      department: "Banking",
      position: "Assistant Manager",
      course: "M.Sc Agronomy",
      batch: "2020-2022",
      ctc: "9 LPA",
      image: saurabh,
      quote: "My time at Maya Devi University was a defining phase of my life. The academic guidance, practical exposure and supportive environment helped shape my career and personal growth. I'm grateful for the foundation it gave me."
    },
    {
      id: 4,
      name: "Shashikant Vasantrao Sasane",
      company: "Farm DSS Agritech Pvt. Ltd.",
      department: "Sales & R & D",
      position: "Regional Sales Manager/ R & D Head",
      course: "MSc Agronomy",
      batch: "2020-2022",
      ctc: "8.2 LPA",
      image: shashikant,
      quote: "Maya Devi University was not just where I earned my degree, it was where I discovered my passion, built lifelong friendships and developed the confidence to pursue my goals. The academic support, practical learning and vibrant campus life played a key role in shaping who I am today."
    },
    {
      id: 5,
      name: "Vaishali Thapa",
      company: "Institute of Agriculture Training and Research, Dehradun",
      department: "Agriculture",
      position: "HOD",
      course: "B.Sc Agriculture",
      batch: "2016-2020",
      ctc: "4.5 LPA",
      image: vaishali,
      quote: "As a B.Sc. Agriculture student from the 2016-2020 batch, my years at Maya Devi University were truly enriching. The academic environment, practical exposure and constant encouragement from faculty helped me build a strong foundation for my future."
    }
  ];

  const nextTestimonial = () => {
    setActiveTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevTestimonial = () => {
    setActiveTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  return (
    <div className="bg-gradient-to-b from-green-50 to-white">
      {/* Header Section with Background */}
      {/* <div className="relative bg-green-800 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img src="/api/placeholder/1920/500" alt="Agriculture background" className="w-full h-full object-cover" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto py-20 px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">School of Agriculture and Technology</h1>
          <p className="text-xl max-w-3xl mx-auto">Cultivating knowledge, harvesting success</p>
        </div>
      </div> */}

      {/* Awards & Recognitions Section */}
      <section className="py-16 px-4 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center p-2 bg-green-100 rounded-full mb-4">
            <FaAward className="text-green-700 text-2xl" />
          </div>
          <h2 className="text-4xl font-bold text-green-800 mb-4">Awards & Recognitions</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            The School of Agriculture and Technology has consistently demonstrated excellence in education, research and community engagement, earning numerous awards and recognitions. These accolades highlight the school's commitment to innovation, sustainability and academic distinction.
          </p>
        </div>

        <div className="overflow-hidden rounded-xl bg-white shadow-xl">
          <table className="min-w-full">
            <thead>
              <tr className="bg-green-700 text-white">
                <th className="py-4 px-6 text-left">Sr No.</th>
                <th className="py-4 px-6 text-left">Name of Faculty</th>
                <th className="py-4 px-6 text-left">Name of Awards/Recognition</th>
                <th className="py-4 px-6 text-left">Date & Year</th>
                <th className="py-4 px-6 text-left">Name of Awarding Agency</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {awards.map((award, index) => (
                <tr key={award.id} className={index % 2 === 0 ? "bg-white" : "bg-green-50"}>
                  <td className="py-4 px-6">{index + 1}</td>
                  <td className="py-4 px-6 font-medium">{award.faculty}</td>
                  <td className="py-4 px-6">{award.award}</td>
                  <td className="py-4 px-6">{award.date}</td>
                  <td className="py-4 px-6">{award.agency}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-16">
          <div className="bg-white rounded-xl overflow-hidden shadow-xl transition-all hover:shadow-2xl">
            <div className="p-1 bg-gradient-to-r from-green-400 to-green-700"></div>
            <div className="p-8">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-green-100 rounded-lg">
                  <FaTrophy className="text-green-700 text-2xl" />
                </div>
                <h3 className="text-2xl font-semibold text-green-800 ml-4">Faculty Achievements</h3>
              </div>
              <div className="space-y-4">
                {awards.map((award) => (
                  <div key={award.id} className="p-4 border-l-4 border-green-500 bg-green-50 rounded-r-lg">
                    <h4 className="text-lg font-medium text-green-800 mb-2">{award.award}</h4>
                    <p className="text-gray-600 mb-1 text-sm"><span className="font-medium">Faculty:</span> {award.faculty}</p>
                    <p className="text-gray-600 mb-1 text-sm"><span className="font-medium">Date:</span> {award.date}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl overflow-hidden shadow-xl transition-all hover:shadow-2xl">
            <div className="p-1 bg-gradient-to-r from-green-400 to-green-700"></div>
            <div className="p-8">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-green-100 rounded-lg">
                  <FaUsers className="text-green-700 text-2xl" />
                </div>
                <h3 className="text-2xl font-semibold text-green-800 ml-4">Student Clubs & Societies</h3>
              </div>
              <div className="space-y-6">
                {clubs.map((club, index) => (
                  <div key={index} className="flex items-center gap-4 p-4 bg-green-50 rounded-lg">
                    <div className="flex-shrink-0 w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                      <FaLeaf className="text-green-600 text-xl" />
                    </div>
                    <div>
                      <h4 className="text-xl font-semibold text-green-800">{club}</h4>
                      <p className="text-gray-600">Student-led initiative</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section with Carousel */}
      <section className="py-16 bg-gradient-to-r from-green-800 to-green-700 text-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center p-2 bg-white bg-opacity-20 rounded-full mb-4">
              <FaMedal className="text-white text-2xl" />
            </div>
            <h2 className="text-4xl font-bold mb-4">Student Success Stories</h2>
            <p className="text-lg max-w-3xl mx-auto opacity-90">
              Hear from our alumni about their transformative experiences at Maya Devi University.
            </p>
          </div>

          <div className="relative px-4 md:px-12">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <div className="grid md:grid-cols-2 bg-white text-gray-800">
                {/* Image Section */}
                <div className="relative h-64 md:h-auto overflow-hidden">
                  <img 
                    src={testimonials[activeTestimonial].image} 
                    alt={`${testimonials[activeTestimonial].name}`} 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex flex-col justify-end p-6">
                    <div className="p-2 bg-green-700 text-white inline-block rounded mb-2 text-sm font-medium">
                      Alumni Success
                    </div>
                    <h3 className="text-xl font-bold text-white">{testimonials[activeTestimonial].name}</h3>
                    <p className="text-green-200">{testimonials[activeTestimonial].position} | {testimonials[activeTestimonial].course}</p>
                  </div>
                </div>

                {/* Content Section */}
                <div className="p-8 md:p-10">
                  <div className="flex items-center mb-6">
                    <div className="bg-green-100 text-green-800 p-3 rounded-full mr-4">
                      <FaUserGraduate size={24} />
                    </div>
                    <div>
                      <h4 className="text-xl font-bold">{testimonials[activeTestimonial].company}</h4>
                      <p className="text-green-700 font-medium">CTC: {testimonials[activeTestimonial].ctc}</p>
                    </div>
                  </div>
                  
                  <div className="mb-8">
                    <div className="flex gap-2 text-sm text-gray-600 mb-4">
                      <span className="px-3 py-1 bg-green-100 rounded-full">{testimonials[activeTestimonial].batch}</span>
                      <span className="px-3 py-1 bg-green-100 rounded-full">{testimonials[activeTestimonial].course}</span>
                    </div>
                    <div className="relative">
                      <FaQuoteLeft className="text-green-200 absolute -top-2 -left-1" size={24} />
                      <p className="text-gray-700 italic pl-8">{testimonials[activeTestimonial].quote}</p>
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <div className="flex gap-2">
                      {testimonials.map((_, index) => (
                        <button 
                          key={index}
                          onClick={() => setActiveTestimonial(index)}
                          className={`w-3 h-3 rounded-full ${activeTestimonial === index ? 'bg-green-600' : 'bg-gray-300'}`}
                          aria-label={`Go to testimonial ${index + 1}`}
                        />
                      ))}
                    </div>
                    <div className="flex gap-2">
                      <button 
                        onClick={prevTestimonial}
                        className="p-2 rounded-full bg-green-100 text-green-700 hover:bg-green-200"
                        aria-label="Previous testimonial"
                      >
                        <FaChevronLeft />
                      </button>
                      <button 
                        onClick={nextTestimonial}
                        className="p-2 rounded-full bg-green-100 text-green-700 hover:bg-green-200"
                        aria-label="Next testimonial"
                      >
                        <FaChevronRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Alumni Showcase Grid */}
      <section className="py-16 px-4 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-green-800 mb-4">Meet Our Successful Alumni</h2>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          Our graduates are making an impact across various sectors of agriculture and related industries.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            className="bg-white rounded-xl overflow-hidden shadow-lg transition-all hover:shadow-xl hover:-translate-y-1"
          >
            <div className="h-48 overflow-hidden flex items-center justify-center">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-full h-full object-contain"
              />
            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-green-800 mb-1">{testimonial.name}</h3>
              <p className="text-green-600 font-medium mb-2">{testimonial.position}</p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-3 py-1 bg-green-100 text-green-800 text-xs rounded-full">{testimonial.course}</span>
                <span className="px-3 py-1 bg-green-100 text-green-800 text-xs rounded-full">{testimonial.batch}</span>
              </div>
              <p className="text-gray-600 text-sm line-clamp-3">{testimonial.quote.substring(0, 100)}...</p>
            </div>
          </div>
        ))}
      </div>
    </section>
    </div>
  );
};

const WhyUsSection = () => {
    const features = [
        {
            icon: <Zap className="w-7 h-7" />,
            title: "Excellence in Education & Innovation",
            description: "We offer a future-ready curriculum that combines deep theoretical knowledge with practical, hands-on experience in cutting-edge technologies such as AI, cyber security, data science, cloud computing, and more."
        },
        {
            icon: <Shield className="w-7 h-7" />,
            title: "Ethics Meets Technology",
            description: "Our programs emphasize not just what you can build, but what you should build—instilling strong ethical values and social responsibility in every technologist we shape."
        },
        {
            icon: <Globe className="w-7 h-7" />,
            title: "Global Readiness",
            description: "We prepare you for a connected world with industry exposure, international collaborations, and real-world projects that enhance your global perspective and professional agility."
        },
        {
            icon: <LucideSearch className="w-7 h-7" />,
            title: "Research & Creativity",
            description: "Whether you're passionate about academic research or innovative product development, you'll have opportunities to explore, create, and solve problems that matter."
        },
        {
            icon: <Users className="w-7 h-7" />,
            title: "Supportive, Inclusive Environment",
            description: "We foster a diverse and inclusive learning culture where every voice is heard and every student is empowered to grow—personally, academically, and professionally."
        },
        {
            icon: <Activity className="w-7 h-7" />,
            title: "Commitment to Lifelong Learning",
            description: "In a fast-evolving tech world, we help you build not just a degree, but a mindset of continuous growth, critical thinking, and lifelong curiosity."
        }
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white p-8 rounded-xl shadow-lg mb-12"
        >
            <div className="flex flex-col md:flex-row gap-8">
                <div className="w-full md:w-1/3">
                    <div className="sticky top-24">
                        <div className="flex items-center gap-3 mb-4">
                            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                                <CheckCircle className="w-6 h-6" />
                            </div>
                            <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Why Choose Us?</h2>
                        </div>
                        <p className="text-gray-700 mb-6">The school of Agriculture and Technology offers a unique and rewarding educational journey that combines innovation, sustainability and real-world impact. Students gain a deep understanding of traditional agricultural practices while exploring cutting-edge technologies such as precision farming, agricultural robotics, GIS, biotechnology, sustainable microbial (biological) technologies and smart irrigation systems. With the global population increasing and climate change threatening food security, there’s a growing need for skilled professionals who can find sustainable solutions. Agriculture and technology graduates are in demand worldwide. From on-campus farms to high-tech labs, students get hands-on experience that prepares them for real-world challenges in agriculture, food systems, and Agri-tech entrepreneurship. Graduates can work in government agencies, agribusiness companies, research institutions, international NGOs, or start their own Agri-tech ventures. The scope is vast and growing. The school encourages creative thinking and innovation, offering support for students interested in launching startups or research projects that can shape the future of agriculture. By joining the school of Agriculture & Technology, students play an active role in tackling global challenges such as food insecurity, climate change and sustainable development making a real difference in the world.</p>
                        <div className="relative h-60 md:h-80 rounded-lg overflow-hidden">
                            <img
                                src={agri2}
                                alt="Students collaborating"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0e4d38] to-transparent p-4">
                                <p className="text-white font-semibold">Ready to become a responsible, visionary leader in Agriculture and Technology? Join us—and build the future with purpose.</p>
                            </div>
                        </div>
                        <div className="mt-6">
                            <Link to="https://admission.maya.edu.in/">
                                <motion.button
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                    className="w-full bg-[#0e4d38] text-white px-6 py-3 rounded-lg text-lg font-semibold flex items-center justify-center gap-2"
                                >
                                    Apply Now
                                    <ArrowRight className="w-5 h-5" />
                                </motion.button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="w-full md:w-2/3">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {features.map((feature, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                className="bg-gray-50 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
                            >
                                <div className="text-[#0e4d38] mb-4">
                                    <div className="p-3 bg-[#0e4d38]/10 rounded-lg inline-block">
                                        {feature.icon}
                                    </div>
                                </div>
                                <h3 className="text-xl font-bold mb-3 text-gray-800">{feature.title}</h3>
                                <p className="text-gray-600">{feature.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-white py-12 md:py-20 px-6 md:px-10 rounded-xl mb-8 md:mb-12">
        <div className="absolute inset-0 bg-[url('/api/placeholder/1600/800')] bg-cover bg-center opacity-10 mix-blend-overlay" aria-hidden="true"></div>
        <div className="absolute -right-20 -bottom-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>
        <div className="absolute -left-20 -top-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>

        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-6xl mx-auto relative z-10"
        >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">
                School of Agriculture & Technology
            </h1>
            <h2 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8 text-green-100">
                Shaping Tomorrow's Leaders at Maya Devi University
            </h2>

            <div className="flex flex-wrap gap-4 md:gap-6">
                <Link to="https://admission.maya.edu.in/">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-white text-[#0e4d38] px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group shadow-lg"
                    >
                        Apply Now
                        <Rocket className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link>
                {/* <Link to="#programs">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-transparent border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group"
                    >
                        Explore Programs
                        <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link> */}
            </div>
        </motion.div>
    </div>
);
const Agriculture = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins mt-[70px]">
            <Title canonicalPath="/programmes/ug-courses/agriculture" />
            <Title title="School of Agriculture and Technology at Maya Devi University" description="Enroll in the School of Agriculture and Technology at MDU, Dehradun. Gain practical skills and knowledge for a successful career in agriculture and tech." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <Stats />
                <AboutSection />
                <DeansWelcome />
                <WhyUsSection />
                <div className="space-y-6 md:space-y-8">
                    {/* <Department
                        title="Bachelor of Technology Programs"
                        icon={<GraduationCap className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={btechCourses}
                    /> */}
                    <Department
                        title="UG Programs"
                        icon={<Leaf className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={bscCourses}
                    />
                    <Department
                        title="PG Programs"
                        icon={<GraduationCap className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={mscCourses}
                    />
                </div>

                <AchievementsSection />
                <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "State-of-the-Art Research Facilities",
                            "Experienced Faculty",
                            "Industry Collaborations",
                            "Modern Laboratory Infrastructure",
                            "Research-Oriented Curriculum",
                            "Hands-On Learning Experience",
                            "International Exposure",
                            "Project-Based Learning",
                            "Research Publications",
                            "Industry Training",
                            "Field Work Opportunities",
                            "Agricultural Innovation Hub"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Briefcase className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Agricultural Scientist",
                            "Food Technologist",
                            "Agronomist",
                            "Horticulturist",
                            "Plant Breeder",
                            "Agricultural Consultant",
                            "Research Scientist",
                            "Farm Manager",
                            "Agricultural Officer",
                            "Quality Control Specialist",
                            "Agricultural Entrepreneur",
                            "Agricultural Extension Officer"
                        ]}
                    />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Agriculture;